import React from 'react';

import { StorageImage } from '@app/types/storage-image';
import Image from '@app/components/image';

import { GalleryStyled, GalleryThumbsStyled } from './gallery-styled';

type GalleryProps = {
  title?: string;
  data: Array<StorageImage>;
  trailer: string;
  showTrailer: () => void;
  openGallery: (id: number) => void;
};

const Gallery = ({
  title = '',
  data,
  showTrailer,
  trailer,
  openGallery,
}: GalleryProps): JSX.Element => {
  const gallerySourceArray = data?.map((item) => item.url);

  function onWatchTrailer() {
    showTrailer();
  }

  const generatingGalleryThumbs = gallerySourceArray?.map((thumb, i = 0) => {
    const key = i + 1;
    return (
      <button type="button" className="gallery-item" key={key} onClick={() => openGallery(key)}>
        <Image
          src={thumb}
          width={196}
          height={196}
          layout="fixed"
          objectFit="cover"
          loading="eager"
        />
      </button>
    );
  });

  return (
    <GalleryStyled>
      <h2>{title}</h2>

      <GalleryThumbsStyled>
        <div className="trailer-item">
          <Image
            src={`https://img.youtube.com/vi/${trailer.substring(
              trailer.lastIndexOf('=') + 1,
            )}/hqdefault.jpg`}
            width={196}
            height={196}
            layout="fixed"
            objectFit="cover"
            loading="eager"
          />
          <button className="video-play" type="button" onClick={() => onWatchTrailer()}>
            <Image
              src="/assets/icons/play.svg"
              width={40}
              height={40}
              layout="fixed"
              objectFit="cover"
              loading="eager"
            />
          </button>
        </div>

        {generatingGalleryThumbs}
      </GalleryThumbsStyled>
    </GalleryStyled>
  );
};

export default Gallery;
